import { useMemo } from 'react';

import PropTypes from 'prop-types';

import { Indicator } from './Indicator';
import * as Styled from './ProgressBar.styles';

function isCompleted(indicatorIndex, currentSlide, isAutoplay) {
  return (
    indicatorIndex < currentSlide
    || (indicatorIndex <= currentSlide && !isAutoplay)
  );
}

function ProgressBar({
  autoplayDuration = 5000, currentSlide = 0, isAutoplay = true, totalSlides = 1
}) {
  const indicators = useMemo(
    () => [...Array(totalSlides).keys()],
    [totalSlides]
  );

  return (
    <Styled.Root horizontal gap={1}>
      {indicators.map((i) => (
        <Indicator
          isCompleted={isCompleted(i, currentSlide, isAutoplay)}
          isInProgress={i === currentSlide}
          key={`slide_${i}`}
          progressDuration={autoplayDuration}
        />
      ))}
    </Styled.Root>
  );
}

ProgressBar.propTypes = {
  autoplayDuration: PropTypes.number,
  currentSlide: PropTypes.number,
  isAutoplay: PropTypes.bool,
  totalSlides: PropTypes.number
};

export default ProgressBar;
